import { Link, useLocation } from "react-router-dom";
import { Home, Gift, User as UserIcon } from "lucide-react";

/**
 * Mobile-first sticky bottom navigation (Taptap Send style).
 * Visible only on screens < md (768px). Hidden on admin / agent / wizard pages.
 */
export default function BottomNav() {
  const { pathname } = useLocation();
  const hide =
    pathname.startsWith("/admin") ||
    pathname.startsWith("/agent/") ||
    pathname === "/envoyer";
  if (hide) return null;

  const items = [
    { to: "/", label: "Accueil", icon: Home, match: (p) => p === "/" },
    { to: "/parrainage", label: "Parrainage", icon: Gift, match: (p) => p.startsWith("/parrainage") },
    { to: "/compte", label: "Compte", icon: UserIcon, match: (p) => p.startsWith("/compte") || p.startsWith("/mes-") },
  ];

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white dark:bg-[color:var(--sl-card-bg)] border-t border-gray-200 dark:border-[color:var(--sl-border)] shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.12)]"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        transform: "translateZ(0)",
        WebkitTransform: "translateZ(0)",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
      }}
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-3 max-w-md mx-auto">
        {items.map(({ to, label, icon: Icon, match }) => {
          const active = match(pathname);
          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center justify-center py-2.5 gap-0.5 transition ${
                active ? "text-[var(--sl-primary)]" : "text-gray-500"
              }`}
              data-testid={`bottom-nav-${to.replace("/", "") || "home"}`}
            >
              <Icon size={20} strokeWidth={active ? 2.4 : 1.9} />
              <span className={`text-[11px] ${active ? "font-semibold" : "font-medium"}`}>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
